import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { AccountType } from '../enums/account-type';

@Injectable({
  providedIn: 'root',
})
export class AccountTypeProviderService {
  /* prettier-ignore */
  private entries = new Map<AccountType, string>([
    [AccountType.User, 'Konto użytkownika'],
    [AccountType.Company, 'Konto firmowe'],
  ]);

  public label(type: AccountType): Observable<string> {
    const entry = this.entries.get(type);

    if (isNil(entry)) {
      throw new EntryNotFoundException(`The entry for "${type}" not found.`);
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<AccountType>[]> {
    const result = Array.from(this.entries.entries()).map(
      ([status, label]) => new SelectItem(label, status),
    );

    return of(result);
  }
}
